/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';
import BehaviorIcon from 'icons/BehaviorIcon';

const messages = defineMessages({
  title: {id: 'navigation.behavior.submitted-concerns'},
});

const SubmittedConcernsItem = () => (
  <RouteLinkItem
    iconBefore={BehaviorIcon}
    route="midas/students/behavior/submitted-concerns"
    title={messages.title}
  />
);

export default SubmittedConcernsItem;
